<template>
  <div class="comment-item" :class="{ reply: isReply }">
    <div class="d-flex align-items-center mb-1">
      <b-avatar variant="danger" class="mr-2">{{ getInitial(comment.author) }}</b-avatar>
      <strong>{{ comment.author }}</strong>
      <small class="text-muted ml-2">{{ formatTime(comment.time) }}</small>
    </div>

    <p class="mb-2">
      <span v-if="comment.parent_id !== 0"><strong>@{{ parentAuthor }}:</strong> </span>
      {{ comment.text }}
    </p>

    <div class="d-flex align-items-center gap-3 mb-2">
      <button class="btn btn-sm btn-link text-danger p-0" @click="toggleReplyForm">Reply</button>
    </div>

    <div v-if="showReplyForm" class="mb-3">
      <b-form @submit.prevent="submitReply">
        <b-form-textarea
          v-model="replyText"
          rows="2"
          placeholder="Write a reply..."
        />
        <b-button
          size="sm"
          type="submit"
          variant="primary"
          class="mt-1"
          :disabled="!replyText.trim()"
        >
          Send Reply
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          class="mt-1 ml-2"
          @click="cancelReply"
        >
          Cancel
        </b-button>
      </b-form>
    </div>

    <div v-if="comment.replies && comment.replies.length">
      <CommentItem
        v-for="(reply, idx) in visibleReplies"
        :key="reply.id || idx"
        :comment="reply"
        :is-reply="true"
        :parent-author="comment.author"
        @reply="forwardReply"
      />

      <div v-if="comment.replies.length > maxVisibleReplies">
        <b-button
          size="sm"
          variant="link"
          class="p-0"
          @click="showAllReplies = !showAllReplies"
        >
          {{ showAllReplies ? 'Show less replies' : 'Show more replies' }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BForm, BFormTextarea, BButton } from 'bootstrap-vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

export default {
  name: 'CommentItem',
  components: {
    BAvatar, BForm, BFormTextarea, BButton,
    CommentItem: () => import('./CommentItem.vue')
  },
  props: {
    comment: Object,
    isReply: Boolean,
    parentAuthor: String
  },
  data() {
    return {
      showReplyForm: false,
      replyText: '',
      showAllReplies: false,
      maxVisibleReplies: 5

    }
  },
  computed: {
    visibleReplies() {
      if (!this.comment.replies) return []
      const sorted = [...this.comment.replies].sort((a, b) => b.time - a.time)
      return this.showAllReplies ? sorted : sorted.slice(0, this.maxVisibleReplies)
    }
  },
  methods: {
    getInitial(name) {
      return name ? name.charAt(0).toUpperCase() : '?'
    },
    formatTime(ts) {
      return dayjs(ts).fromNow()
    },
    toggleReplyForm() {
      this.showReplyForm = !this.showReplyForm
    },
    cancelReply() {
      this.replyText = ''
      this.showReplyForm = false
    },
    submitReply() {
      if (!this.replyText.trim()) return
      const replyObj = {
        text: this.replyText.trim()
      }
      this.$emit('reply', this.comment, replyObj)
      this.replyText = ''
      this.showReplyForm = false
    },
    forwardReply(parent, replyObj) {
      this.$emit('reply', parent, replyObj)
    }
  }
}
</script>

<style scoped>
.comment-item {
  margin-bottom: 1.5rem;
}

.comment-item.reply {
  padding-left: 20px;
  border-left: 2px solid #eee;
}

.comment-item.reply .comment-item.reply {
  padding-left: 0;
  border-left: none;
}
</style>
